import { GuideContentWrapped, FactoryTypes, DecisionStep } from "../models";

const getStepCount = (steps: GuideContentWrapped[]) => steps.map(elem => 
    elem.type === FactoryTypes.NUMBERED_STEP ? 1 : 
     // eslint-disable-next-line @typescript-eslint/no-use-before-define
     elem.type === FactoryTypes.DECISION_STEP ? getDecisionStepCount(elem.content as DecisionStep)[1] : 0
).reduce((a, b) => a + b);

export const getDecisionStepCount = (decisionStep: DecisionStep): number[] => {
    const stepNumRange = [];
    
    if(typeof decisionStep.yesSteps !== 'undefined' && decisionStep.yesSteps?.length > 0){
        stepNumRange.push(getStepCount(decisionStep.yesSteps));
    }
    if(typeof decisionStep.noSteps !== 'undefined' && decisionStep.noSteps?.length > 0){
        stepNumRange.push(getStepCount(decisionStep.noSteps));
    }
    if(typeof decisionStep.decisionOptions !== 'undefined'){
        decisionStep.decisionOptions.forEach(item => {
            stepNumRange.push(getStepCount(item.steps));
        });
    }

    stepNumRange.sort((a, b) => a - b);

    return [stepNumRange[0], stepNumRange[stepNumRange.length - 1]];
};
